import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { Moment } from "moment";

export interface getGraphHourAvgHistorical_item {
  date: string; // ISO string
  hour: number;
  // Each requested parameter will come as `${parameter}_avg`
  so2_avg?: string;
  no2_avg?: string;
  pm1_avg?: string;
  pm25_avg?: string;
  pm10_avg?: string;
  temp_avg?: string;
  humi_avg?: string;
  wind_speed_avg?: string;
  wind_direction_avg?: string;
}
export interface getHourAvgHistorical_Returns {
  status: string;
  location_id: number;
  frequency: string;
  total_data: number;
  data: getGraphHourAvgHistorical_item[];
}

export const getGraphHourAvgHistorical = async (
  dev_id: string,
  start_datetime: Moment,
  end_datetime: Moment,
  frequency: string,
  params_list: string[]
): Promise<AxiosResponse<getHourAvgHistorical_Returns>> => {
  const config: AxiosRequestConfig = {
    method: "post",
    url: `https://monster1.distronix.in:1443/avgdata/v2.0/get_average_data`,
    data: {
      location_id: dev_id,
      start_time: start_datetime.format("YYYY-MM-DD HH:mm:ss"),
      end_time: end_datetime.format("YYYY-MM-DD HH:mm:ss"),
      frequency: frequency,
      parameter_list: params_list,
    },
  };
  const result: AxiosResponse<getHourAvgHistorical_Returns> = await axios(
    config
  );
  return result;
};
